const BASE_BACKDROP_Z_INDEX = 1050
const BASE_MODAL_Z_INDEX = 1055
const STACK_STEP = 20

let modalOrderCounter = 0

function getOpenModals(): HTMLElement[] {
  return Array.from(document.querySelectorAll<HTMLElement>('.modal.show[data-modal-order]'))
    .sort((a, b) => Number(a.dataset.modalOrder) - Number(b.dataset.modalOrder))
}

function syncModalStack() {
  const openModals = getOpenModals()

  openModals.forEach((modalEl, index) => {
    const modalId = modalEl.id
    const backdrop = document.querySelector<HTMLElement>(`.modal-backdrop[data-modal-id="${modalId}"]`)
    const backdropZIndex = BASE_BACKDROP_Z_INDEX + index * STACK_STEP
    const modalZIndex = BASE_MODAL_Z_INDEX + index * STACK_STEP

    modalEl.style.zIndex = String(modalZIndex)

    if (backdrop) {
      backdrop.style.zIndex = String(backdropZIndex)
    }
  })

  if (openModals.length > 0) {
    document.body.classList.add('modal-open')
  } else {
    document.body.classList.remove('modal-open')
  }
}

const modal = {
  Open(id: string, top: number = 0) {
    const modalEl = document.getElementById(id)
    if (modalEl) {
      modalOrderCounter += 1

      modalEl.classList.add('show')
      modalEl.style.display = 'block'
      modalEl.style.top = top + '%'
      modalEl.dataset.modalOrder = String(modalOrderCounter)

      const existing = document.querySelector(`.modal-backdrop[data-modal-id="${id}"]`)
      if (!existing) {
        const backdrop = document.createElement('div')
        backdrop.className = 'modal-backdrop fade show'
        backdrop.setAttribute('data-modal-id', id)
        document.body.appendChild(backdrop)
      }

      syncModalStack()
    }
  },

  Close(id: string) {
    const modalEl = document.getElementById(id)
    if (modalEl) {
      modalEl.classList.remove('show')
      modalEl.style.display = 'none'
      modalEl.style.zIndex = ''
      delete modalEl.dataset.modalOrder
    }

    const backdrop = document.querySelector(`.modal-backdrop[data-modal-id="${id}"]`)
    if (backdrop && backdrop.parentNode) {
      backdrop.parentNode.removeChild(backdrop)
    }

    syncModalStack()
  },
}

export default modal